export default function slice(arrayLike, start) {
    start = start|0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for(var idx = 0; idx < newLen; idx++)  {
        newArr[idx] = arrayLike[start + idx];
    }
    return newArr;
}



//////////////////
// WEBPACK FOOTER
// ./~/async-es/internal/slice.js
// module id = rVn3
// module chunks = 0